import React, { useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import Busy from '@Images/admin/integrations/busylogo2.png';
import TallyPng from '@Images/admin/integrations/tally.png';
import ZohoBooksPng from '@Images/admin/integrations/zoho.png';
import UniCommerce from '@Images/admin/integrations/unicommerce.png';
import Shopify from '@Images/admin/integrations/shopify.png';
import Whatsapp from '@Images/admin/integrations/whatsapp.png';
import Xero from '@Images/logos/xero.png';
import Quickbooks from '@Images/logos/quickbooks.png';
import './styles.scss';
/**
 *
 */
const IntegrationCard = ({
  connected, type, disabled, onClick, enabled,
}) => {
  useEffect(() => {
  }, []);

  const getIntegrationImage = () => {
    if (type === 'tally') {
      return TallyPng;
    }
    if (type === 'zoho') {
      return ZohoBooksPng;
    }
    if (type === 'unicommerce') {
      return UniCommerce;
    }
    if (type === 'shopify') {
      return Shopify;
    }
    if (type === 'whatsapp') {
      return Whatsapp;
    }
    if (type === 'xero') {
      return Xero;
    }
    if (type === 'quickbooks') {
      return Quickbooks;
    }
    if (type === 'busy') {
      return Busy;
    }

    return null;
  };

  return (
    <Fragment>
      <div
        className={`${disabled && 'opacity-5 pointer-none'} integration-card__wrapper`}
        onClick={() => (((!disabled && enabled)) && onClick())}
      >
        <div
          className="integration-card"
        >
          <img
            src={getIntegrationImage()}
            alt="agent-logo"
            className="integration-logo"
          />
          {/*
          {disabled && (
            <div className="integration-footer">
              <p className="integration-footer-text">Coming Soon</p>
            </div>
          ) } */}
          {!enabled && (
            <div
              type="primary"
              className="integration-card_btn-disable"
            >
              Not Enabled
            </div>
          ) }

          {enabled && connected ? (
            <div
              type="primary"
              className="integration-card_btn"
            >
              Connected
            </div>
          ) : null}

        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
});

const mapDispatchToProps = () => ({

});

IntegrationCard.propTypes = {
  connected: PropTypes.any,
  type: PropTypes.any,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  enabled: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IntegrationCard));
